<header class="login-dialog__header">
  <span>{{ 'Inicia sesión' | translate }}</span>
  <button type="button" class="login-dialog__close-btn" (click)="dismissDialog()">&#x2715;</button>
</header>

<div class="login-dialog__content">
  <form class="login-dialog__form" [formGroup]="loginForm" (ngSubmit)="login()">
    <p>{{ '¡Te damos la bienvenida a Cicerone!' | translate }}</p>

    <div class="form-group-login">
      <label class="labels">
        <span>{{ 'Correo electrónico' | translate }}</span> *
      </label>
      <div class="divInputStyle">
        <input class="inputs-pdf" autocomplete="off" type="text" (focusin)="focusin($event)" formControlName="email" />
      </div>
    </div>

    <div class="form-group-login">
      <label class="labels">
        <span>{{ 'Contraseña' | translate }}</span> *
      </label>
      <div class="divInputStyle">
        <input class="inputs-pdf" autocomplete="off" [type]="passwordType" (focusin)="focusin($event)" formControlName="password" />
        <button type="button" class="show-button" (click)="showPassword()">
          {{ passwordType === 'password' ? '👁' : '👁‍🗨' }}
        </button>
      </div>
    </div>

    <div class="action-wrapper">
      <div class="action-wrapper__remember">
        <span>{{ 'Recordarme' | translate }}</span>
        <div>
          <input type="checkbox" id="login-dialog-switch" formControlName="remember" />
          <label id="login-dialog-label-switch" for="login-dialog-switch">Toggle</label>
        </div>
      </div>
      <span class="action-wrapper__forget" (click)="recoverPassword()">{{ 'He olvidado mi contraseña' | translate }}</span>
    </div>

    <button type="submit" class="submit-button">{{ 'Iniciar sesión' | translate }}</button>

    @if (loginFailed()) {
      <app-office-access-link [email]="loginForm.get('email')?.value" [snackbarContainer]="snackbarContainer" />
    }

    <div class="action-divider">
      <hr />
      <span>{{ 'o' | translate }}</span>
      <hr />
    </div>

    <app-social-login-buttons></app-social-login-buttons>

    <button type="button" (click)="register()" class="submit-button">{{ 'Regístrate' | translate }}</button>
  </form>
</div>
